"use strict";

/**
 * Define the output of this file. The output of CSS and JS file will be auto detected.
 *
 * @output js/scripts.bundle
 */

// Core Plugins
window.KTUtil = require("../../src/assets/js/global/components/base/util");
window.KTApp = require("../../src/assets/js/global/components/base/app");
window.KTHeader = require("../../src/assets/js/global/components/base/header-07-05-22");
window.KTMenu = require("../../src/assets/js/global/components/base/menu");
window.KTOffcanvas = require("../../src/assets/js/global/components/base/offcanvas");
window.KTScrolltop = require("../../src/assets/js/global/components/base/scrolltop");
window.KTToggle = require("../../src/assets/js/global/components/base/toggle");
require("../../src/assets/js/global/components/base/datatable/core.datatable");
require("../../src/assets/js/global/components/base/datatable/datatable.checkbox");
require("../../src/assets/js/global/components/base/datatable/datatable.rtl");

// Layout Scripts
require("../../src/assets/js/global/layout/quick-search");

// Layout Scripts
window.KTLayout = require("../../src/assets/js/global/layout/layout");
require("../../src/assets/js/global/layout/demo-panel");
require("../../src/assets/js/global/layout/offcanvas-panel");
require("../../src/assets/js/global/layout/quick-panel");
